import { type Customer } from "@repo/api";

import { useSettings } from "../settings/SettingsProvider";
import { getCustomerName, maskProjectTitle } from "../utils/customerHelpers";

interface ProjectTitleProps {
  title: string;
  customer?: Customer;
  customerName?: string;
  organizationName?: string;
}

export const ProjectTitle = ({
  title,
  customer,
  customerName,
  organizationName,
}: ProjectTitleProps) => {
  const { customerMode, general } = useSettings();

  // Apply for both individual and business, as the project title might contain both
  const individualNameFromCustomer =
    getCustomerName(
      {
        firstName: customer?.firstName,
        lastName: customer?.lastName,
        customerType: "Individual",
      },
      general?.localization?.reverse_names
    ) || "";

  const individualName = individualNameFromCustomer || customerName || "";

  const businessName = organizationName || customer?.organizationName || "";

  return (
    <>
      {customerMode
        ? maskProjectTitle(title, individualName, businessName)
        : title}
    </>
  );
};
